import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { colorForStatus, statusToString } from '../utils/msisdnUtils';
import { STATUS_ACTIVE, STATUS_NOT_ACTIVE, STATUS_ONBOARDING } from '../Constants';
import { useTranslation } from "react-i18next";

const MsisdnStatusDropdown = ({ status, onChange }) => {

    let previousStatus = status;
    const { t } = useTranslation()

    function handleStatusChange(newStatus) {
        if (newStatus !== previousStatus) {
            onChange(newStatus);
            previousStatus = newStatus;
        }
    }

    return (
        <Dropdown>
            <Dropdown.Toggle variant={colorForStatus(status)} id="dropdown-basic" className="w-100 py-2 px-2"
                style={{
                    fontSize: '0.755rem',
                    lineHeight: '1.25rem',
                    height: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {statusToString(status, t)}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item onClick={() => { handleStatusChange(STATUS_ACTIVE) }}>{statusToString(STATUS_ACTIVE, t)}</Dropdown.Item>
                <Dropdown.Item onClick={() => { handleStatusChange(STATUS_ONBOARDING) }}>{statusToString(STATUS_ONBOARDING, t)}</Dropdown.Item>
                <Dropdown.Item onClick={() => { handleStatusChange(STATUS_NOT_ACTIVE) }}>{statusToString(STATUS_NOT_ACTIVE, t)}</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default MsisdnStatusDropdown;